import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import './ImageSlide.css'

class ImageSlide extends Slide {

    render() {
        
        return super.render(
            <div className='ImageSlide'>
                <span className='ImageSlide-Title'>{ this.props.title }</span>
                {this.props.subtitle && <span className='ImageSlide-Subtitle'>{ this.props.subtitle }</span>}
                <img className='ImageSlide-Img' src={this.props.img} />
            </div>
        )
    }
}
 
ImageSlide.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    img: PropTypes.string.isRequired
}

export default ImageSlide;





// WEBPACK FOOTER //
// ./src/components/ImageSlide.js